export const bookingSortingTypes = {
  all: 'all',
  ongoing: 'ongoing',
  upcoming: 'upcoming',
  past: 'past',
  canceled: 'canceled'
};

export const bookingSortingList = [
  {
    name: 'acc-booking-sorting-all',
    type: bookingSortingTypes.all,
    params: '',
    id: 'qa_booking-sorting-all'
  },
  {
    name: 'acc-booking-sorting-ongoing',
    type: bookingSortingTypes.ongoing,
    params: '',
    id: 'qa_booking-sorting-ongoing'
  },
  {
    name: 'acc-booking-sorting-upcoming',
    type: bookingSortingTypes.upcoming,
    params: 'arrival=upcoming&canceled=false',
    id: 'qa_booking-sorting-upcoming'
  },
  {
    name: 'acc-booking-sorting-past',
    type: bookingSortingTypes.past,
    params: 'departure=past&canceled=false',
    id: 'qa_booking-sorting-past'
  },
  {
    name: 'acc-booking-sorting-canceled',
    type: bookingSortingTypes.canceled,
    params: 'canceled=true',
    id: 'qa_booking-sorting-canceled'
  }
];
